export default __webpack_public_path__ + "static/media/data-table.f2dc82e5.svg";